<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header">
        <h3 class="page-title">{{ $t('general.credit_limit') }}</h3>
      </div>
      <div class="row">
        <div class="col-md-6 mb-6">
          <label class="input-label">{{ $tc('general.credit_limit') }}</label>
          <div class="base-read-box base-read-box-field">
            <div v-html="$utils.formatMoney(credit_limit, customerCurrencyViewFormat)" />
          </div>
        </div>
        <div class="col-md-6 mb-6">
          <label class="input-label">{{ $tc('general.used_credit') }}</label>
          <div class="base-read-box base-read-box-field">
            <div v-html="$utils.formatMoney(used_credit, customerCurrencyViewFormat)" />
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <p class="text-center"> Total Credit Limit <span v-html="$utils.formatMoney(total_credit_limit, customerCurrencyViewFormat)"/></p>
          <pie-chart
            v-if="isLoading"
            :labels="CrditLimitLabels"
            :values="CreditLimitData"
            :bg-colors="bgColors"
            :hover-bg-colors="hoverBgColors"
            :type="'pie'"
          />
        </div>
      </div>

    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import PieChart from '../../../components/chartjs/PieChart'
export default {
  components: {
    PieChart
  },
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      used_credit: 0,
      credit_limit: 0,
      hoverBgColors: [],
      bgColors: ['#33FF71', '#FF3F33'],
      PieData: [],
      CreditLimitData: [],
      CrditLimitLabels: [],
      total_credit_limit: 0
    }
  },
  computed: {
    ...mapGetters('funder', [
      'viewFunder'
    ]),
    customerCurrencyViewFormat () {
      if (this.viewFunder && this.viewFunder.account && this.viewFunder.account.currency) {
        return this.viewFunder.account.currency
      }
      if (this.viewFunder && this.viewFunder.currency) {
        return this.viewFunder.currency
      }
    }
  },
  created () {
    this.loadData()
  },
  validations: {},
  mounted () {},
  methods: {
    ...mapActions('funder', [
      'fetchViewFunder'
    ]),
    ...mapActions('companyImpactOthers', [
      'addCompanyImpactOthers',
      'getImpact'
    ]),
    async loadData () {
      let response
      if (this.viewFunder && this.viewFunder.account && this.viewSupplier.account.default_company_id && localStorage.getItem('selectedCompany')) {
        let data = {
          company_id: this.viewFunder.account.default_company_id,
          guest_company_id: localStorage.getItem('selectedCompany')
        }
        response = await this.getImpact(data)
      } else {
        let customer_response = await this.fetchViewFunder(this.$route.params.id)
        if (customer_response.data && customer_response.data.account.default_company_id) {
          let data = {
            company_id: customer_response.data.account.default_company_id,
            guest_company_id: localStorage.getItem('selectedCompany')
          }
          response = await this.getImpact(data)
        }
      }
      if (response.data.used_credit) {
        this.used_credit = response.data.used_credit
      }
      if (response.data.credit_limit) {
        this.credit_limit = (response.data.credit_limit) * 100
      }
      if (response.data.credit_limit && (response.data.used_credit || response.data.used_credit == 0)) {
        this.isLoading = true
        this.CrditLimitLabels = response.data.credit_limit_data.labels
        this.CreditLimitData = response.data.credit_limit_data.chart
        this.total_credit_limit = response.data.credit_limit_data.total_credit_limit
      }
    }
  }
}
</script>
